<template>
    <div>
      <el-table
        v-if="showTable"
        :data="tableList"
        border
        :header-row-style="tableHeaderStyle"
        :header-cell-style="tableHeaderStyle"
        empty-text="ไม่พบข้อมูล"
        :default-sort="{ prop: 'index', order: 'ascending' }"
        class="disabled-on-print"
      >
        <el-table-column
          type="index"
          label="ลำดับ"
          header-align="center"
          align="center"
          width="80"
          sortable
        ></el-table-column>
        <el-table-column
          prop="nameTH"
          label="ชื่อ"
          header-align="center"
          align="center"
          sortable
          :width="widthMax < 767.98 ? '170' : ''"
        ></el-table-column>
         <el-table-column
          prop="surnameTH"
          label="นามสกุล"
          header-align="center"
          align="center"
          sortable
          :width="widthMax < 767.98 ? '170' : ''"
        ></el-table-column>
         <el-table-column
          prop="institution"
          label="ชื่อบริษัท"
          header-align="center"
          align="center"
          sortable
          :width="widthMax < 767.98 ? '170' : ''"
        ></el-table-column>
         <el-table-column
          prop="mobilephone"
          label="เบอร์โทรศัพท์"
          header-align="center"
          align="center"
          sortable
          :width="widthMax < 767.98 ? '170' : ''"
        ></el-table-column>
         <el-table-column
          prop="email"
          label="อีเมล"
          header-align="center"
          align="center"
          sortable
          :width="widthMax < 767.98 ? '170' : ''"
        ></el-table-column>
        <el-table-column
          :prop="fieldDate"
          :label="labelDate"
          :width="
            widthMax < 767.98
              ? '120'
              : widthMax < 1199
              ? '120'
              : widthMax > 1200
              ? '250'
              : ''
          "
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">{{
            scope.row[fieldDate] | dateTimeTh
          }}</template>
        </el-table-column>
        <el-table-column v-if="showAction" label width="100" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex-display ai-center js-center">
              <div class="box-action">
                <div
                  @click="
                    $router.push(
                      `/dashboard/user/score?courseId=${courseId}&userId=${scope.row._id}`
                    )
                  "
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-eye"></i>
                </div>
              </div>
              <div class="box-action">
                <div
                  @click="print(scope.row)"
                  class="circle-action color-bg-secondary"
                >
                  <i class="fas fa-print"></i>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>


    </div>
</template>

<script>
import { tableHeaderStyle } from "@/service/table";
import { HTTP } from "@/service/axios.js";

export default {
    computed: {
        token() {
        return this.$store.state.token;
        },
    },
    props: {
        tableList: {
            type: Array,
            default() {
                return [];
            },
        },
        showAction: {
            type: Boolean,
            default() {
                return false;
            },
        },
        labelDate:{
            type:String,
            default(){
                return 'วันที่และเวลาที่สมัคร'
            }
        },
        fieldDate:{
            type:String,
            default(){
                return 'createdAt'
            }
        },
        courseId:{
            type:String,
            default(){
                return ''
            }
        },
    },
    data() {
        return {
            widthMax: window.innerWidth,
            showTable:false,

        };
    },
    mounted() {
        window.addEventListener("resize", this.resize);
        setTimeout(() => {
            this.showTable = true
        }, 200);
    },
    methods: {
        resize() {
            this.showTable = false
            this.widthMax= window.innerWidth
            setTimeout(() => {
                this.showTable = true
            }, 200);

        },
        print(data) {
            this.$emit('print',data)
        },
    },
};
</script>